import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { FhqInvitationState } from '@reducers/fhq-invitation-settings';

export const getFhqInvitationSettings = (state: RootState): FhqInvitationState => state.fhqInvitationSettings;
export const getFhqInvitationSettingsData = createSelector(getFhqInvitationSettings, (settings) => settings?.data);
export const isFhqInvitationSettingsLoading = createSelector(getFhqInvitationSettings, (settings) => settings?.loading);
